import { AppPath } from '@ipensii/shared/domain-shared';

export enum AdminPath {
  admin = AppPath.admin,
  componentInfo = 'component-info',
  provider = 'provider',
  request = 'request',
  sign = 'sign',
  view = 'view',
  employer = 'employer',
  hrEmployees = 'hr-employees',
  notificationDashboard = 'notificationDashboard',
  notification = 'notification',
  settings = 'settings',
  events = 'events',
  exception = 'exception',
  jobDashboard = 'jobDashboard',
  job = 'job',
  jobDefinitionList = 'job-definition-list',
  jobExecutionList = 'job-execution-list',
  jobLogList = 'job-log-list',
  reportingDashboard = AppPath.reportingDashboard,
}

export enum AdminPathParam {
  providerId = 'providerId',
  requestId = 'requestId',
  employerId = 'employerId',
}

export class AdminRouterLinkBuilder {
  static adminDashboard(): Array<unknown> {
    return ['/', AdminPath.admin];
  }

  static requestAdmin(): Array<unknown> {
    return [...AdminRouterLinkBuilder.adminDashboard(), AdminPath.request];
  }

  static employerAdmin(): Array<unknown> {
    return [...AdminRouterLinkBuilder.adminDashboard(), AdminPath.employer];
  }

  static requestSigning({ requestId }: { requestId: string }): Array<unknown> {
    return [...AdminRouterLinkBuilder.requestAdmin(), requestId, AdminPath.sign];
  }

  static requestView({ requestId }: { requestId: string }): Array<unknown> {
    return [...AdminRouterLinkBuilder.requestAdmin(), requestId, AdminPath.view];
  }

  static employer({ employerId }: { employerId: string }): Array<unknown> {
    return [...AdminRouterLinkBuilder.employerAdmin(), employerId];
  }

  static hrEmployees({ employerId }: { employerId: string }): Array<unknown> {
    return [...AdminRouterLinkBuilder.employerAdmin(), employerId, AdminPath.hrEmployees];
  }
}
